// Intentionally global
___export = require('./../../lib/src-server/azure-server').setDirName(__dirname).serve(require('./../../lib/src-server/example-function').main);
module.exports = ___export;


//////////////////
// WEBPACK FOOTER
// ./deployment/example-function/build.source.js
// module id = 285
// module chunks = 4